import React from "react";
import { CopyRightDivStyled } from "./CopyRightDiv.styled";
import moment from "moment/moment";

// Get version from global config.js
const version = window.version;

const CopyRightDiv = () => {
  const year = moment().year();

  return (
    <CopyRightDivStyled>
      <div className="copyRightdiv">
        <div className="nest">
          <p className="copy_content">
            Copyright © {year}. All Rights Reserved. Patent Pending. version{" "}
            {version}
          </p>
        </div>
      </div>
    </CopyRightDivStyled>
  );
};

export default CopyRightDiv;
